import { motion } from 'framer-motion';
import React, { useEffect, useRef } from 'react';
import QdtComponent from '../../components/QdtComponent';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';

export default function Scoreboards() {
	const playerInputRef = useRef<HTMLInputElement>(null)
	const entrantInputRef = useRef<HTMLInputElement>(null)

	const {goToTop, clearAllSelections} = useApp()

	useEffect(() => {
    goToTop()

		entrantInputRef.current?.blur();
		playerInputRef.current?.blur();
  }, [goToTop])


  return (
		<motion.div variants={fadeIn} initial="hidden" animate="show">
		<section className="" >
			<section className="subs-bg-img bg-img-property mb-2 pb-2">
					<div className="container">
						<div className="section-width">
						<h2 className="section-margin-bottom text-light">Our Scorecards</h2>
					</div>
					<div className="row mb-3">
						<div className="col "><h6 className="section-grp-margin-bottom text-light fs-3">Filters</h6></div>
						<div className="col text-light text-end">
							<button onClick={() => clearAllSelections()} className="btn btn-warning text-success">Clear Selections</button>
						</div>
					</div>
					<div className="row mb-3">
						<div className="col-12">
							<div className="row">
								<div className="col-6 col-md-6 border-end border-light">
									<p className="text-start text-light fs-6">Player</p> 
									<QdtComponent
										ref={playerInputRef}
										type='QdtSearch'
										props={{
											cols: ['Player'],
											placeholder: 'Player Search...',
										}}
									/>					
								</div>
								<div className="col-6 col-md-6">
									<p className="text-start text-light fs-6">Entrant</p> 
									<QdtComponent
										ref={entrantInputRef}
										type='QdtSearch'
										props={{
											cols: ['Entrant'],
											placeholder: 'Entrant Search...',
										}}
									/>					
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-3 col-sm-12 border-end border-light">
							<p className="text-start text-light fs-6">Round</p> 
							<QdtComponent
								type="QdtFilter"
								props={{
									cols: ['Round'],
									placeholder: 'Round',
									expandedHorizontal: true,
									autoSortByState: 0
								}}
							/>								
						</div>
						<div className="col-lg-3 border-end border-light pb-2">
								<p className="text-start text-light fs-6">Side</p> 
								<QdtComponent
									type="QdtFilter"
									props={{
										cols: ['Side'],
										placeholder: 'Side',
										expandedHorizontal: true,
										autoSortByState: 0
									}}
								/>							
						</div>
						<div className="col-lg-6 col-sm-12">
						<p className="text-lg-center text-sm-start text-light fs-6">Hole</p> 
									<QdtComponent
										type="QdtFilter"
										props={{
											cols: ['Hole'],
											placeholder: 'Hole',
											expandedHorizontal: true,
											autoSortByState: 0
										}}
									/>				
						</div>
					</div>
				</div>
			</section>
			<div className="container">
				<div className="row rowsafari">
					<div className="pb-3">
						<div className="border border-success rounded mb-3">
							<QdtComponent 
								type="QdtViz"
								props={{
									id: 'bHQRDzN',
									height: `400px`,
								}}
							/>
						</div>
						<div className="border border-success rounded">
							<QdtComponent 
								type="QdtViz"
								props={{
									id: 'WuqQgm',
									height: '400px',
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
		</motion.div>
  )
}